// extracted by mini-css-extract-plugin
export default {"multiline":"MultilineText_multiline__XMHR5"};